import React, { Fragment } from "react";
import Seo from "./Seo";

function Header({ children, marginTop, marginBottom }) {
  return (
    <h1 className="title product-header" style={{ marginTop, marginBottom }}>
      {children}
    </h1>
  );
}

function Subheader({ children, marginTop, marginBottom, centered }) {
  return (
    <h2
      className="subtitle product-subheader"
      style={{ marginTop, marginBottom, textAlign: centered }}
    >
      {children}
    </h2>
  );
}

function DescriptionImage({ src, iconIsLarger }) {
  return (
    <div
      className="product-description-image"
      style={{
        width: iconIsLarger ? "100%" : "75px",
        height: iconIsLarger ? "100%" : "60px"
      }}
    >
      <img src={src} alt="" loading="lazy" />
    </div>
  );
}

function ProductContentTemplate({
  url,
  header,
  subheader,
  descriptionContent,
  iconHpposition,
  features,
  solution,
  support,
  precision,
  marginTop,
  iconIsLarger,
  processing,
  smartrViewPic,
  cascadianCaseStudiesHeader,
  shouldBeDescription
}) {
  return (
    <section className="section">
      <Seo title={header} description={descriptionContent || subheader} path={`/${url}`} />
      <div className="container">
        <Header>{header}</Header>
        <Subheader marginTop="80px">{subheader}</Subheader>
        {shouldBeDescription && (
          <div className="columns product-description">
            <div className={`${iconIsLarger ? "column is-6" : "column is-1"} product-description-icon`}>
              <DescriptionImage src={iconHpposition} iconIsLarger={iconIsLarger} />
            </div>
            <div className="column product-description-content">
              {smartrViewPic && <img src={smartrViewPic} alt="" loading="lazy" />}
              {descriptionContent}
            </div>
          </div>
        )}
        {cascadianCaseStudiesHeader && (
          <span className="cascadian-case-studies-header">
            {cascadianCaseStudiesHeader}
          </span>
        )}
        {features.map(item => (
          <div className="columns product-description product-description-column" key={item.header}>
            <div className="column is-1 product-description-icon">
              <DescriptionImage src={item.icon} />
            </div>
            <div className="column product-description-content">
              <Header>{item.header}</Header>
              {item.description}
            </div>
          </div>
        ))}
        {solution &&
          solution.map(item => (
            <Fragment key={item.header}>
              <hr className="product-hr" />
              <Header>{item.header}</Header>
              <Subheader marginBottom="50px">{item.subheader}</Subheader>
              <div className="columns product-description">
                <div className="column is-1 product-description-icon">
                  <DescriptionImage src={item.icon} />
                </div>
                <div className="column product-description-content">
                  {item.description}
                </div>
              </div>
            </Fragment>
          ))}
        <hr className="product-hr" />
        {processing && (
          <>
            <Header marginBottom="50px">{processing.header}</Header>
            <div className="product-processing">
              {processing.features.map(item => (
                <div className="product-processing-half" key={item.title}>
                  <Subheader centered="center" marginBottom="10px">
                    {item.title}
                  </Subheader>
                  {item.desc}
                </div>
              ))}
            </div>
            <div className="product-processing-image">
              <img src={processing.img} alt="" loading="lazy" />
            </div>
            <hr className="product-hr" />
          </>
        )}
        {precision && (
          <>
            <Header marginTop="50px">{precision.header}</Header>
            {marginTop && <div style={{ marginTop }} />}
            <img src={precision.image} alt="" loading="lazy" />
            <p className="product-support-description">{precision.description}</p>
            <hr className="product-hr" />
          </>
        )}
        {support && (
          <Fragment>
            <Header marginTop="50px">{support.header}</Header>
            <img src={support.image} alt="" loading="lazy" />
            <p className="product-support-description">{support.description}</p>
          </Fragment>
        )}
      </div>
    </section>
  );
}

export default ProductContentTemplate;
